import { NgModule } from '@angular/core';
import { NoContentComponent } from './no-content.component';

/**
 * `NoContentModule`
 *
 * Embedding <no-content> component
 */
@NgModule({
    declarations: [
        NoContentComponent
    ]
})
export class NoContentModule {
}



// WEBPACK FOOTER //
// ./src/app/no-content/no-content.module.ts